import {BASE_API} from '../../utils/constantes'
import { getToken } from './token'
import { withCache, TTL } from '../../services/apiCache'

// Función original sin caché
async function _getProvincias(){
   
    try {
        
        const url =  `${BASE_API}/api/provincia/`
            
        const params = {
            headers:{
                Authorization:`Bearer ${getToken()}`
            }
        }
        const response = await fetch(url,params)
       
        if(response.status === 200){
           
            const result= await response.json()
            
            return result
            
        }
        return false
        
    } catch (error) {
        throw new Error ("Credenciales invalidas")
    }
}

// Función exportada con caché (1 hora de TTL)
export const getProvincias = withCache(_getProvincias, TTL.LONG, (forceRefresh) => {
    return `getProvincias_${forceRefresh || ''}`;
});